// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conatiner-painel-educacao {
  padding: 60px 20px !important;
}

.cadastros-educacao {
  display: flex;
  justify-content: space-evenly;
  gap: 10px;
}

.cadastros-educacao  > a {
    position: relative;
    color: var(--texto);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 40%;
    padding: 20px;
    box-shadow: .8px .8px 3px 0 #dedede;
    border-radius: 6px;
    cursor: pointer;
    transition: all .3s ease-in-out;
  }

:is(.cadastros-educacao > a):hover {
      scale: 1.03;
    }

:is(.cadastros-educacao > a)  > p {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
    }

:is(.cadastros-educacao > a) .icon {
      color: var(--azul2);
      font-size: 20px;
    }


@media screen and (max-width: 800px) {
  .cadastros-educacao {
    gap: 4%;
    text-align: center;
    flex-wrap: wrap;
  }

    .cadastros-educacao  > a {
      width: 46%;
      flex-direction: column;
    }

      :is(.cadastros-educacao > a)  > p {
        flex-direction: column;
        align-items: center;
        gap: 10px;
        font-size: 14px;
      }

      :is(.cadastros-educacao > a) .icon {
        color: var(--azul2);
        font-size: 20px;
      }
}

.edit-icon-button,
.edit-icon-button:hover {
  border: none;
}

/* Painel SEDUC */
.seduc-container {
  padding: 30px 20px;
}

.seduc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.seduc-search {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #d7e3ff;
  border-radius: 12px;
  background: #ffffff !important;
  font-size: 14px;
  outline: none;
}

.seduc-search-wrapper {
  position: relative;
  flex: 1 1;
}

.seduc-search-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #7a8aad;
  pointer-events: none;
  font-size: 20px;
}

.seduc-search {
  padding-left: 30px !important;
}

.seduc-badge {
  padding: 6px 10px;
  background: #f1f5ff;
  color: #1f4b99;
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
}

.seduc-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 18px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.seduc-card {
  background: linear-gradient(135deg, #f2f6ff 0%, #edf1ff 100%);
  border: 1px solid #e3e9ff;
  border-radius: 14px;
  padding: 14px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

.seduc-card.card-blue {
  background: linear-gradient(135deg, #dce7ff 0%, #eef3ff 100%);
}

.seduc-card.card-green {
  background: linear-gradient(135deg, #d8f1e2 0%, #e8f8ef 100%);
}

.seduc-card.card-purple {
  background: linear-gradient(135deg, #e7dbff 0%, #f3edff 100%);
}

.seduc-card.card-orange {
  background: linear-gradient(135deg, #ffe9d6 0%, #fff2e5 100%);
}

.seduc-card.card-cyan {
  background: linear-gradient(135deg, #d8f0ff 0%, #ebf8ff 100%);
}

.seduc-card.card-pink {
  background: linear-gradient(135deg, #ffe1ec 0%, #fff0f7 100%);
}

.seduc-card.active {
  box-shadow: 0 8px 18px rgba(31, 71, 126, 0.18);
  transform: translateY(-2px);
}

.seduc-card .label {
  color: #4a5a85;
  font-size: 13px;
  margin-bottom: 6px;
}

.seduc-card strong {
  font-size: 20px;
  color: #1f2d55;
  line-height: 1.2;
}

.seduc-section {
  background: #fff;
  border: 1px solid #e7ecf5;
  border-radius: 16px;
  padding: 16px;
  margin-top: 16px;
  box-shadow: 0 6px 18px rgba(31, 71, 126, 0.06);
}

.seduc-section.two-col {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 12px;
}

.seduc-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.seduc-tag {
  padding: 4px 8px;
  background: #eef3ff;
  color: #1f4b99;
  border-radius: 8px;
  font-size: 12px;
}

.seduc-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.seduc-list.seduc-list--table {
  background: #f5f7ff;
  padding: 10px;
  border-radius: 14px;
  border: 1px solid #e2e8f4;
}

.seduc-row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 60px;
  text-align: left;
  border: 1px solid #e7ecf5;
  border-radius: 12px;
  background: #f9fbff;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.seduc-row:hover {
  border-color: #c7d6ff;
  box-shadow: 0 4px 12px rgba(31, 71, 126, 0.06);
}

.seduc-row .title {
  font-weight: 700;
  color: #1f2d55;
}

.seduc-row .muted {
  color: #5f6a86;
  font-size: 13px;
}

.seduc-row .badge {
  padding: 6px 8px;
  border-radius: 8px;
  background: #e9edf7;
  color: #1f2d55;
  font-size: 12px;
}

.seduc-row .badge.success {
  background: #e7f6ed;
  color: #1c7c3e;
}

.seduc-row .badge.danger {
  background: #fde9e9;
  color: #c62828;
}

.seduc-row .right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.seduc-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: min(640px, 90vw);
  height: 100vh;
  background: #ffffff;
  border-left: 1px solid #dfe5f5;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
  padding: 40px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.25s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.seduc-drawer__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.seduc-drawer__header  > h4 {
    color: var(--texto-destaque);
    border-bottom: 2px solid var(--borda);
    width: 200px;
    padding-bottom: 4px;
    font-size: 18px;
  }

.seduc-drawer__body {
  overflow: auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.seduc-drawer--wide {
  width: min(780px, 92vw);
}

.seduc-drawer__body--grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  align-content: start;
}

.seduc-drawer__row {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid #e7ecf5;
}

.seduc-drawer__row .label {
  color: #707070;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.seduc-drawer__row .value {
  color: #122140;
  font-weight: 600;
  font-size: 16px;
  text-align: left;
  word-break: break-word;
}

.close-btn {
  border: none;
  cursor: pointer;
  font-size: 25px;
  font-weight: 100;
  line-height: 1;
}

@media screen and (max-width: 800px) {
  .seduc-section.two-col {
    grid-template-columns: 1fr;
  }
}

.seduc-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.28);
  z-index: 999;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Educacao/educacao.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AA+BX;;AA7BE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,+BAA+B;EAiBjC;;AAfE;MACE,WAAW;IACb;;AAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;IACV;;AAEA;MACE,mBAAmB;MACnB,eAAe;IACjB;;;AAKJ;EACE;IACE,OAAO;IACP,kBAAkB;IAClB,eAAe;EAkBjB;;IAhBE;MACE,UAAU;MACV,sBAAsB;IAaxB;;MAXE;QACE,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;QACT,eAAe;MACjB;;MAEA;QACE,mBAAmB;QACnB,eAAe;MACjB;AAGN;;AAEA;;EAEE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,uDAAuD;EACvD,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AASrB;;AAPE;IACE,4BAA4B;IAC5B,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;AAGF;EACE,cAAc;EACd,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".conatiner-painel-educacao {\n  padding: 60px 20px !important;\n}\n\n.cadastros-educacao {\n  display: flex;\n  justify-content: space-evenly;\n  gap: 10px;\n\n  >a {\n    position: relative;\n    color: var(--texto);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 40%;\n    padding: 20px;\n    box-shadow: .8px .8px 3px 0 #dedede;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all .3s ease-in-out;\n\n    &:hover {\n      scale: 1.03;\n    }\n\n    >p {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 5px;\n    }\n\n    .icon {\n      color: var(--azul2);\n      font-size: 20px;\n    }\n  }\n}\n\n\n@media screen and (max-width: 800px) {\n  .cadastros-educacao {\n    gap: 4%;\n    text-align: center;\n    flex-wrap: wrap;\n\n    >a {\n      width: 46%;\n      flex-direction: column;\n\n      >p {\n        flex-direction: column;\n        align-items: center;\n        gap: 10px;\n        font-size: 14px;\n      }\n\n      .icon {\n        color: var(--azul2);\n        font-size: 20px;\n      }\n    }\n  }\n}\n\n.edit-icon-button,\n.edit-icon-button:hover {\n  border: none;\n}\n\n/* Painel SEDUC */\n.seduc-container {\n  padding: 30px 20px;\n}\n\n.seduc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.seduc-search {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #d7e3ff;\n  border-radius: 12px;\n  background: #ffffff !important;\n  font-size: 14px;\n  outline: none;\n}\n\n.seduc-search-wrapper {\n  position: relative;\n  flex: 1;\n}\n\n.seduc-search-icon {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #7a8aad;\n  pointer-events: none;\n  font-size: 20px;\n}\n\n.seduc-search {\n  padding-left: 30px !important;\n}\n\n.seduc-badge {\n  padding: 6px 10px;\n  background: #f1f5ff;\n  color: #1f4b99;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.seduc-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n  margin-bottom: 18px;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.seduc-card {\n  background: linear-gradient(135deg, #f2f6ff 0%, #edf1ff 100%);\n  border: 1px solid #e3e9ff;\n  border-radius: 14px;\n  padding: 14px 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  min-height: 110px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n}\n\n.seduc-card.card-blue {\n  background: linear-gradient(135deg, #dce7ff 0%, #eef3ff 100%);\n}\n\n.seduc-card.card-green {\n  background: linear-gradient(135deg, #d8f1e2 0%, #e8f8ef 100%);\n}\n\n.seduc-card.card-purple {\n  background: linear-gradient(135deg, #e7dbff 0%, #f3edff 100%);\n}\n\n.seduc-card.card-orange {\n  background: linear-gradient(135deg, #ffe9d6 0%, #fff2e5 100%);\n}\n\n.seduc-card.card-cyan {\n  background: linear-gradient(135deg, #d8f0ff 0%, #ebf8ff 100%);\n}\n\n.seduc-card.card-pink {\n  background: linear-gradient(135deg, #ffe1ec 0%, #fff0f7 100%);\n}\n\n.seduc-card.active {\n  box-shadow: 0 8px 18px rgba(31, 71, 126, 0.18);\n  transform: translateY(-2px);\n}\n\n.seduc-card .label {\n  color: #4a5a85;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n\n.seduc-card strong {\n  font-size: 20px;\n  color: #1f2d55;\n  line-height: 1.2;\n}\n\n.seduc-section {\n  background: #fff;\n  border: 1px solid #e7ecf5;\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 16px;\n  box-shadow: 0 6px 18px rgba(31, 71, 126, 0.06);\n}\n\n.seduc-section.two-col {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 12px;\n}\n\n.seduc-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.seduc-tag {\n  padding: 4px 8px;\n  background: #eef3ff;\n  color: #1f4b99;\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.seduc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.seduc-list.seduc-list--table {\n  background: #f5f7ff;\n  padding: 10px;\n  border-radius: 14px;\n  border: 1px solid #e2e8f4;\n}\n\n.seduc-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 60px;\n  text-align: left;\n  border: 1px solid #e7ecf5;\n  border-radius: 12px;\n  background: #f9fbff;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.seduc-row:hover {\n  border-color: #c7d6ff;\n  box-shadow: 0 4px 12px rgba(31, 71, 126, 0.06);\n}\n\n.seduc-row .title {\n  font-weight: 700;\n  color: #1f2d55;\n}\n\n.seduc-row .muted {\n  color: #5f6a86;\n  font-size: 13px;\n}\n\n.seduc-row .badge {\n  padding: 6px 8px;\n  border-radius: 8px;\n  background: #e9edf7;\n  color: #1f2d55;\n  font-size: 12px;\n}\n\n.seduc-row .badge.success {\n  background: #e7f6ed;\n  color: #1c7c3e;\n}\n\n.seduc-row .badge.danger {\n  background: #fde9e9;\n  color: #c62828;\n}\n\n.seduc-row .right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.seduc-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: min(640px, 90vw);\n  height: 100vh;\n  background: #ffffff;\n  border-left: 1px solid #dfe5f5;\n  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);\n  padding: 40px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.25s ease;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n.seduc-drawer__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n\n  >h4 {\n    color: var(--texto-destaque);\n    border-bottom: 2px solid var(--borda);\n    width: 200px;\n    padding-bottom: 4px;\n    font-size: 18px;\n  }\n}\n\n.seduc-drawer__body {\n  overflow: auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.seduc-drawer--wide {\n  width: min(780px, 92vw);\n}\n\n.seduc-drawer__body--grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n  align-content: start;\n}\n\n.seduc-drawer__row {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  background: transparent;\n  border-bottom: 1px solid #e7ecf5;\n}\n\n.seduc-drawer__row .label {\n  color: #707070;\n  font-weight: 500;\n  font-size: 12px;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.seduc-drawer__row .value {\n  color: #122140;\n  font-weight: 600;\n  font-size: 16px;\n  text-align: left;\n  word-break: break-word;\n}\n\n.close-btn {\n  border: none;\n  cursor: pointer;\n  font-size: 25px;\n  font-weight: 100;\n  line-height: 1;\n}\n\n@media screen and (max-width: 800px) {\n  .seduc-section.two-col {\n    grid-template-columns: 1fr;\n  }\n}\n\n.seduc-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.28);\n  z-index: 999;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
